// extracted by mini-css-extract-plugin
export default {"cls1":"dT8jrgo8E_9I689aZsOq","cls2":"FRmC_xtKNfSIiCD60YrZ dT8jrgo8E_9I689aZsOq","isInvalid":"MiIuUf8E0GN040LP6GUI"};